import config from '@/config';
import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import axios from 'axios';
import { onServerPrefetch, toValue, type MaybeRefOrGetter } from 'vue';

export const getOfficesQueryKey = () => ['offices'];
export const officesQuery = async (city?: string) => {
  let url = isSSR ? `${config.BACKEND.URL}/agencies` : '/api/offices';
  if (city) {
    url += `/${city}`;
  }
  logger.info(`Fetching offices data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      logger.info('Offices: Got response:', { data: res.data });
      return res.data;
    })
    .catch((err) => {
      logger.info('Offices: Got error:', err);
      return Promise.reject(err);
    });
};

export default function useOfficesData(city?: MaybeRefOrGetter<string>) {
  logger.info('useOfficesData()');
  const query = useQuery({
    queryKey: [getOfficesQueryKey, city],
    queryFn: () => officesQuery(toValue(city)),
  });

  onServerPrefetch(async () => {
    const queryClient = useQueryClient();
    await queryClient.prefetchQuery({ queryKey: [getOfficesQueryKey, city] });
  });

  return query;
}
